import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { Users, Megaphone, Umbrella } from 'lucide-react';
import EmpleadosTab from './EmpleadosTab';
import ComunicadosTab from './ComunicadosTab';
import AusenciasTab from './AusenciasTab';
import { useAuth } from '../../context/AuthContext';

/**
 * Sección "Personas": agrupa Empleados, Ausencias y Comunicados bajo sub-pestañas.
 * Reduce la cantidad de pestañas principales del panel admin y evita
 * problemas de overflow en pantallas medianas.
 */
const PersonasTab = () => {
  const { puede } = useAuth();
  const puedeComunicados = puede('comunicados');
  const puedeAusencias = puede('ausencias');
  const [tab, setTab] = useState('empleados');

  return (
    <div className="space-y-4" data-testid="personas-tab">
      <Tabs value={tab} onValueChange={setTab} className="space-y-4">
        <TabsList className="bg-zinc-100 p-1 h-auto inline-flex" data-testid="personas-subtabs">
          <TabsTrigger value="empleados" data-testid="subtab-empleados"
            className="data-[state=active]:bg-white data-[state=active]:shadow-sm">
            <Users className="h-4 w-4 mr-2" /> Empleados
          </TabsTrigger>
          {puedeAusencias && (
            <TabsTrigger value="ausencias" data-testid="subtab-ausencias"
              className="data-[state=active]:bg-white data-[state=active]:shadow-sm">
              <Umbrella className="h-4 w-4 mr-2" /> Ausencias
            </TabsTrigger>
          )}
          {puedeComunicados && (
            <TabsTrigger value="comunicados" data-testid="subtab-comunicados"
              className="data-[state=active]:bg-white data-[state=active]:shadow-sm">
              <Megaphone className="h-4 w-4 mr-2" /> Comunicados
            </TabsTrigger>
          )}
        </TabsList>
        <TabsContent value="empleados"><EmpleadosTab /></TabsContent>
        {puedeAusencias && (
          <TabsContent value="ausencias"><AusenciasTab /></TabsContent>
        )}
        {puedeComunicados && (
          <TabsContent value="comunicados"><ComunicadosTab /></TabsContent>
        )}
      </Tabs>
    </div>
  );
};

export default PersonasTab;
